import React, { FC, useEffect } from 'react';
import NavigationBar from './NavigationBar';
import { TPrivacyStatementProps } from '../../types/PrivacyStatement.types';
import { PrivacyStatementModel } from '../../models/PrivacyStatement.model';
import SectionContent from '../SectionContent';
import { documentService } from '../../../../utils/window.utils.js';
import Dropdown from '../Dropdown';
import './index.scss';

const MobilePrivacyStatement: FC<TPrivacyStatementProps> = (props: TPrivacyStatementProps) => {
  const model = new PrivacyStatementModel(props);

  useEffect(() => {
    documentService()?.body.scrollIntoView();
  }, []);


  return (
    <section className="privacy-statement-mobile">
      <div className="privacy-statement__title">{model.title.value}</div>
      <Dropdown
        languageCollection={model.languageCollection}
        changeLanguageTitle={model.changeLanguageTitle?.value || ''}
        languageTitle={model.defaultLanguageTitle?.value || ''}
      />
      <NavigationBar privacyContentItems={model.items} />
      <section className="privacy-statement__content">
        {
          model?.items && model.items.map((item) => {
            return (
              <div className="privacy-statement__content-tab" id={item.id}>
                <SectionContent {...item} />
              </div>
            )
          })
        }
      </section>
    </section>

  )
};

export default MobilePrivacyStatement;
